import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17 3a.99.99 0 0 1 .625.22l.082.073 9 9a1 1 0 0 1 .284.571L27 13v12a4 4 0 0 1-3.8 3.995L23 29H9a4 4 0 0 1-3.995-3.8L5 25V7a4 4 0 0 1 3.8-3.995L9 3h8zm-1 2H9a2 2 0 0 0-1.995 1.85L7 7v18a2 2 0 0 0 1.85 1.995L9 27h14a2 2 0 0 0 1.995-1.85L25 25V14h-5a4 4 0 0 1-3.98-3.597l-.015-.203L16 10V5zm7.585 7L18 6.415V10a2 2 0 0 0 1.85 1.995L20 12h3.585z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }